<div (clickOutside)="clickOutside()" class="wrapper">
  <div [class.is-open]="isDropdownOpen" class="dropdown-title">
    <span class="icon icon-SquaresFour"></span>
    <div (click)="toggleDropdown() "
         class="main">
      <div class="selected-item"> {{ selectedLabel }}</div>
      <span class="icon icon-CaretDown"></span>
    </div>
  </div>

  @if (isDropdownOpen) {
    <div class="dropdown-body" [class.long]="HELPER.frLoc === E_FR_LOC.de">
      @for (item of categoryList; track item; ) {
        <div class="item">
          <mat-checkbox
            [indeterminate]="item.value === E_CONTENT_TAG_TYPE.AllThree && !checkIsAllSelected() && !checkIsAllUnSelected()"
            (change)="selectionChange(item)"
            (click)="$event.stopPropagation()"
            [(ngModel)]="item.checked">
            {{ item.DisplayName | translate }}
          </mat-checkbox>
        </div>
      }
      <div class="dropdown-footer">
        <app-button
          ariaLabel="Cancel"
          (clicked)="cancelSelection()"
          [buttonStyleType]="ButtonTypes.SECONDARY_0">{{ 'Cancel' | translate }}
        </app-button>
        <app-button
          ariaLabel="Apply"
          (clicked)="applySelection()"
          [buttonStyleType]="ButtonTypes.PRIMARY_0">{{ 'Apply' | translate }}
        </app-button>
      </div>
    </div>
  }


</div>
